import { doAppGraphqlRequest } from 'ducks/requests/operations'
import { responseQuery } from './queries'
import {
  AI_REQUEST,
  FETCH_AI_JOB_INSTANT_REPLY_RESULT,
  INSTANT_REPLY_TYPE,
  ACTION_RPC_METHOD_MAP,
  FETCH_AI_JOB_COMPOSER_RESULT,
  COMPOSER_TYPE,
} from './types'

export const getAiType = requestType => {
  switch (requestType) {
    case INSTANT_REPLY_TYPE:
      return FETCH_AI_JOB_INSTANT_REPLY_RESULT
    case COMPOSER_TYPE:
      return FETCH_AI_JOB_COMPOSER_RESULT
    default:
      throw new Error('Unhandled AI type')
  }
}

export const doFetchJobResult = (jobId, options = {}) => {
  const requestType = getAiType(options.requestType)
  return doAppGraphqlRequest(requestType, responseQuery, { id: jobId }, options)
}

export const doAiFailed = requestType => dispatch =>
  dispatch({
    type: `${getAiType(requestType)}_FAILED`,
  })

export const doCancelAiResult = requestType => dispatch =>
  dispatch({
    type: `${getAiType(requestType)}_CANCEL`,
  })

export const doClearState = requestType => dispatch => {
  dispatch({
    type: `${getAiType(requestType)}_CLEAR`,
  })
}

export const doHidePrompt = requestType => dispatch => {
  dispatch({
    type: `${getAiType(requestType)}_HIDE`,
  })
}

export const doInitializeRequest = (requestType, aiType) => dispatch => {
  dispatch({
    type: `${getAiType(requestType)}_INITIALIZE`,
    payload: {
      aiType,
    },
  })
}

export const doAiEnd = (
  requestType,
  retryVariables,
  retryOptions,
  value
) => dispatch => {
  dispatch({
    type: `${requestType}_END`,
    payload: {
      result: value,
      loading: false,
      loaded: true,
      error: null,
      lastRequest: {
        variables: retryVariables,
        options: retryOptions,
      },
    },
  })
}

export const doAiRequest = (query, variables, options = {}) => {
  return doAppGraphqlRequest(AI_REQUEST, query, variables, options)
}

export const getRpcMethodFromActionId = id => {
  return ACTION_RPC_METHOD_MAP[id] || ''
}
